const getters = {
    sidebar: state => state.app.sidebar,
    token: state => state.user.token,
    userId: state => state.user.userId,
    avatar: state => state.user.avatar,
    username: state => state.user.username,
    type: state => state.user.type,
    accountType: state => state.user.accountType,
    account: state => state.user.account,
    roles: state => state.user.roles,
    //permission_routers: state => state.permission.routers,
    routers: state => state.permission.routers,
    operation: state => state.permission.operation,
    schoolId: state => state.user.schoolId,
};
export default getters



// WEBPACK FOOTER //
// ./vue/store/getters.js